import {db} from '@/firebase/config.js'
import { collection, getDocs, doc, getDoc, updateDoc, arrayUnion, query, orderBy, where, limit, startAfter, onSnapshot, getCountFromServer } from 'firebase/firestore'

import store from '@/store';


// created this function to replace the moment dependecies
// moment().valueOf() function was used previously...
// so instead of using it, i've used the vanilla js
const getCurrentDateInMillis = () => {
    const currentDate = new Date();
    const currentDateMillis = currentDate.getTime();
    return currentDateMillis;
  }

// get all claimants list
export const fetchClaimants = async (type = null) => {

    // let querySnapshot = await getDocs(query(collection(db,'claimants'), orderBy('email')))
    let querySnapshot = await getDocs(query(collection(db,'claimants'), orderBy('metadata.updatedOn', 'desc')))

    // switch (type) {
    //     case 'pendings':
    //             // querySnapshot = await getDocs(query(
    //             //     collection(db,'claimants'), 
    //             //     where('achievementBoxInfoStatus', '!=', 'approved'),
    //             //     where('postExamSurveyInfoStatus', '!=', 'approved'),
    //             //     orderBy('email')
    //             // ));

    //             querySnapshot = await getDocs(query(
    //                 collection(db, 'claimants'),
    //                 where('achievementBoxInfoStatus', '!=', 'approved'),
    //                 where('postExamSurveyInfoStatus', '!=', 'approved'),
    //                 orderBy('email')
    //             ));

    //         break;
    //     case 'approved':
    //         querySnapshot = await getDocs(query(collection(db,'claimants'), where('achievementBoxInfoStatus','==','approved'),where('postExamSurveyInfoStatus','==','approved'), orderBy('email')))
    //         break;
    
    //     default:
    //         querySnapshot = await getDocs(query(collection(db,'claimants'), orderBy('email')))
    //         break;
    // }

    let claimants = [];
    querySnapshot.forEach((doc)=>{

        claimants.push({
            id: doc.id,
            data: doc.data()
        })

    })


    return claimants;
}

export const CLAIMANTS_PAGE_SIZE = 50

const claimantsTabCache = {}
const claimantsRevisionCallbacks = new Set()
let claimantsRevisionKey = null
let claimantsRevisionUnsub = null
let claimantsTotalCount = null

const claimantsTabKey = (tab) => (tab == null ? 'all' : tab)

const claimantsRevisionFingerprint = (snap) => {
    const item = snap.docs[0]
    if (!item) return 'empty'
    const meta = item.data().metadata || {}
    return `${item.id}:${meta.updatedOn || ''}`
}

const ensureClaimantsRevisionListener = () => {
    if (claimantsRevisionUnsub) return
    claimantsRevisionUnsub = onSnapshot(
        query(collection(db, 'claimants'), orderBy('metadata.updatedOn', 'desc'), limit(1)),
        (snap) => {
            const next = claimantsRevisionFingerprint(snap)
            const changed = claimantsRevisionKey !== null && next !== claimantsRevisionKey
            claimantsRevisionKey = next
            if (!changed) return
            Object.keys(claimantsTabCache).forEach((key) => { delete claimantsTabCache[key] })
            claimantsTotalCount = null
            claimantsRevisionCallbacks.forEach((fn) => fn())
        },
        (error) => {
            console.error('Error watching claimants collection', error)
        }
    )
}

export const getClaimantsTabCache = (tab) => claimantsTabCache[claimantsTabKey(tab)] || null

export const setClaimantsTabCache = (tab, state) => {
    claimantsTabCache[claimantsTabKey(tab)] = state
}

export const clearClaimantsTabCache = () => {
    Object.keys(claimantsTabCache).forEach((key) => { delete claimantsTabCache[key] })
}

export const fetchClaimantsTotalCount = async ({ force } = {}) => {
    if (!force && claimantsTotalCount !== null) return claimantsTotalCount
    const snap = await getCountFromServer(collection(db, 'claimants'))
    claimantsTotalCount = snap.data().count
    return claimantsTotalCount
}

export const subscribeClaimantsRevision = (onChange) => {
    if (typeof onChange === 'function') claimantsRevisionCallbacks.add(onChange)
    ensureClaimantsRevisionListener()
    return () => {
        claimantsRevisionCallbacks.delete(onChange)
    }
}

export const matchesClaimantTab = (data, tab) => {
    const abox = data && data.achievementBoxInfoStatus
    const pes = data && data.postExamSurveyInfoStatus
    const forfeited = !!(data && data.isForfeited)
    switch (tab) {
        case 'pendings':
            return !forfeited && (abox === 'submitted' || pes === 'submitted') && abox !== 'rejected' && pes !== 'rejected'
        case 'rejected':
            return !forfeited && (abox === 'rejected' || pes === 'rejected')
        case 'approved':
            return !forfeited && abox === 'approved' && pes === 'approved'
        case 'shipped':
            return !forfeited && (abox === 'shipped' || abox === 'returned' || abox === 'received')
        case 'forfeited':
            return forfeited
        default:
            return true
    }
}

const submittedMs = (data) => {
    const value = data && data.metadata ? data.metadata.submittedOn : null
    const n = parseInt(value, 10)
    return Number.isNaN(n) ? 0 : n
}

const snapshotRows = (snap) => {
    const rows = []
    snap.forEach((item) => {
        rows.push({ id: item.id, data: item.data() })
    })
    return rows
}

const runSubmittedPage = async (constraints, cursor, pageSize) => {
    const parts = constraints.concat([orderBy('metadata.submittedOn', 'desc')])
    if (cursor) parts.push(startAfter(cursor))
    parts.push(limit(pageSize))
    const snap = await getDocs(query(collection(db, 'claimants'), ...parts))
    return {
        rows: snapshotRows(snap),
        cursor: snap.docs.length ? snap.docs[snap.docs.length - 1] : cursor,
        hasMore: snap.docs.length === pageSize,
    }
}

export const fetchClaimantsPage = async ({
    tab = null,
    cursor = null,
    cursors = null,
    pageSize = CLAIMANTS_PAGE_SIZE,
    seenIds = [],
} = {}) => {
    const seen = {}
    seenIds.forEach((id) => { seen[id] = true })
    const tabKey = tab || 'all'

    const takeUnseenMatching = (rows) => {
        const next = []
        rows.forEach((row) => {
            if (seen[row.id]) return
            if (!matchesClaimantTab(row.data, tabKey === 'all' ? null : tabKey)) return
            seen[row.id] = true
            next.push(row)
        })
        return next
    }

    if (tabKey === 'pendings' || tabKey === 'rejected') {
        const branches = tabKey === 'pendings'
            ? [
                [where('achievementBoxInfoStatus', '==', 'submitted')],
                [where('postExamSurveyInfoStatus', '==', 'submitted')],
            ]
            : [
                [where('achievementBoxInfoStatus', '==', 'rejected')],
                [where('postExamSurveyInfoStatus', '==', 'rejected')],
            ]
        // Dual queries cannot exclude forfeited in Firestore (missing isForfeited
        // is not false). Keep paging until this tab has a full page of matches.
        const maxFillRounds = 20
        let first = cursors && cursors[0] ? cursors[0] : null
        let second = cursors && cursors[1] ? cursors[1] : null
        let moreFirst = true
        let moreSecond = true
        const collected = []
        let rounds = 0
        while (collected.length < pageSize && (moreFirst || moreSecond) && rounds < maxFillRounds) {
            rounds += 1
            const pages = await Promise.all([
                moreFirst
                    ? runSubmittedPage(branches[0], first, pageSize)
                    : Promise.resolve({ rows: [], cursor: first, hasMore: false }),
                moreSecond
                    ? runSubmittedPage(branches[1], second, pageSize)
                    : Promise.resolve({ rows: [], cursor: second, hasMore: false }),
            ])
            first = pages[0].cursor
            second = pages[1].cursor
            moreFirst = pages[0].hasMore
            moreSecond = pages[1].hasMore
            collected.push(...takeUnseenMatching(pages[0].rows.concat(pages[1].rows)))
        }
        collected.sort((a, b) => submittedMs(b.data) - submittedMs(a.data))
        return {
            rows: collected,
            cursor: null,
            cursors: [first, second],
            hasMore: moreFirst || moreSecond,
        }
    }

    let constraints = []
    if (tabKey === 'approved') {
        constraints = [
            where('achievementBoxInfoStatus', '==', 'approved'),
            where('postExamSurveyInfoStatus', '==', 'approved'),
        ]
    } else if (tabKey === 'shipped') {
        constraints = [where('achievementBoxInfoStatus', 'in', ['shipped', 'returned', 'received'])]
    } else if (tabKey === 'forfeited') {
        constraints = [where('isForfeited', '==', true)]
    }

    const page = await runSubmittedPage(constraints, cursor, pageSize)
    return {
        rows: takeUnseenMatching(page.rows),
        cursor: page.cursor,
        cursors: null,
        hasMore: page.hasMore,
    }
}

export const fetchClaimantsByEmail = async (rawEmail) => {
    const email = String(rawEmail || '').trim()
    if (!email) return []
    const variants = [email]
    const lower = email.toLowerCase()
    if (lower !== email) variants.push(lower)
    const snaps = await Promise.all(variants.map((value) => (
        getDocs(query(collection(db, 'claimants'), where('email', '==', value), limit(5)))
    )))
    const byId = {}
    snaps.forEach((snap) => {
        snap.forEach((item) => {
            byId[item.id] = { id: item.id, data: item.data() }
        })
    })
    return Object.values(byId)
}

const USER_FETCH_CHUNK = 25
const ABOX_APPROVED_STATUSES = {
    approved: true,
    shipped: true,
    returned: true,
    received: true,
}

const fetchDocsById = async (collectionName, ids) => {
    const byId = {}
    for (let i = 0; i < ids.length; i += USER_FETCH_CHUNK) {
        const chunk = ids.slice(i, i + USER_FETCH_CHUNK)
        const snaps = await Promise.all(chunk.map((id) => getDoc(doc(db, collectionName, id))))
        snaps.forEach((snap, idx) => {
            if (snap.exists()) {
                byId[chunk[idx]] = snap.data()
            }
        })
    }
    return byId
}

export const fetchClaimantListExtras = async (rows, existingSchools = null) => {
    const schools = existingSchools || await fetchSchools(true)
    const missingUserIds = []
    const missingAboxIds = []
    const seenUsers = {}
    const seenAbox = {}

    rows.forEach((row) => {
        const data = row.data || {}
        const hasName = !!(data.fullName && String(data.fullName).trim())
        const hasSchoolInfo = !!(data.schoolId || (data.schoolShorthand && String(data.schoolShorthand).trim()))
        if ((!hasName || !hasSchoolInfo) && row.id && !seenUsers[row.id]) {
            seenUsers[row.id] = true
            missingUserIds.push(row.id)
        }
        const hasApprovedOn = !!(data.achievementBoxApprovedOn)
        if (!hasApprovedOn && ABOX_APPROVED_STATUSES[data.achievementBoxInfoStatus] && row.id && !seenAbox[row.id]) {
            seenAbox[row.id] = true
            missingAboxIds.push(row.id)
        }
    })

    const [usersById, aboxById] = await Promise.all([
        fetchDocsById('users', missingUserIds),
        fetchDocsById('achievement_box', missingAboxIds),
    ])

    return { schools: schools, usersById: usersById, aboxById: aboxById }
}

// get all schools list
// return can be object or in array
export const fetchSchools = async (isInObject = false) => {
    const querySnapshot = await getDocs(collection(db,'schools'))
    let objSchools = {};
    let arrSchools = [];

    querySnapshot.forEach((doc)=>{

        if (isInObject) {
            objSchools[doc.id] = doc.data()
        }else{
            arrSchools.push({
                id: doc.id,
                data: doc.data()
            })
        }
    })

    return isInObject ? objSchools : arrSchools;

}

// get user or claimant information in claimants collection
export const getClaimantsInfo = async (userId) => {
    const docSnap = await getDoc(doc(db, 'claimants', userId));
    return docSnap.exists() ? docSnap.data() : null;
}

export const fetchUserScorecard = async (userId) => {

    const res = [];

    const q = query(
        collection(db, 'exam_results'),
        where('userId','==', userId)
    );
    
    // Execute the query
    await getDocs(q)
        .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            // Access document data here
            res.push({
                id: doc.id,
                data: doc.data()
            })
        });
        })
        .catch((error) => {
        console.log('Error getting documents: ', error);
        });

        return res;

}

export const fetchUserKtrs = async (userId) => {
    const docSnap = await getDoc(doc(db, 'exam_result_ktrs', userId));
    return docSnap.exists() ? docSnap.data().ktrs : [];

}

// get user informatio
export const getUserInfo = async (userId) => {
    const docSnap = await getDoc(doc(db, 'users', userId));
    return docSnap.exists() ? docSnap.data() : null;
}

// get post exam survey information
export const getPostExamSurvey = async (docId) => {
    const docSnap = await getDoc(doc(db, 'post_exam_survey', docId));
    return docSnap.exists() ? docSnap.data() : null;
}

// get achievement box information
export const getAchievementBox = async (docId) => {
    const docSnap = await getDoc(doc(db, 'achievement_box', docId));
    return docSnap.exists() ? docSnap.data() : null;
}


export const rejectAchievementBox = async (docId, rejectReason) => {

    // get the rejected count first
    const docSnap = await getDoc(doc(db, 'achievement_box', docId));
    const rejectCount = docSnap.exists() && docSnap.data().metadata.rejected ? docSnap.data().metadata.rejected : 0;
    const curDate = getCurrentDateInMillis().toString();

    return await Promise.all([
        updateDoc(doc(db,'achievement_box',docId), {
            status: 'rejected',
            'metadata.updatedOn' : curDate,
            'metadata.rejected' : rejectCount + 1,
            reasonsForRejection: arrayUnion(rejectReason)
        }),
        updateDoc(doc(db,'claimants',docId), {
            achievementBoxInfoStatus: 'rejected',
            'metadata.updatedOn' : curDate,
        })
    ])

}


export const approveAchievementBox = async (docId) => {

    const curDate = getCurrentDateInMillis().toString();
    // get email of the admin user
    const curAuthUser = store.state.user.otherInfo.email;

    return await Promise.all([
        updateDoc(doc(db,'achievement_box', docId), {
            status: 'approved',
            'metadata.updatedOn' : curDate,
            'metadata.approvedOn' : curDate,
            'metadata.approvedBy' : curAuthUser
        }),
        updateDoc(doc(db,'claimants', docId), {
            achievementBoxInfoStatus: 'approved',
            achievementBoxApprovedOn: curDate,
            'metadata.updatedOn' : curDate,
        })
    ])

}


export const rejectPostExamSurvey = async (docId, rejectReason) => {

    // get the rejected count first
    const docSnap = await getDoc(doc(db, 'post_exam_survey', docId));
    const rejectCount = docSnap.exists() && docSnap.data().metadata.rejected ? docSnap.data().metadata.rejected : 0;
    const curDate = getCurrentDateInMillis().toString();

    return await Promise.all([
        updateDoc(doc(db,'post_exam_survey',docId), {
            status: 'rejected',
            'metadata.updatedOn' : curDate,
            'metadata.rejected' : rejectCount + 1,
            reasonsForRejection: arrayUnion(rejectReason)
        }),
        updateDoc(doc(db,'claimants',docId), {
            postExamSurveyInfoStatus: 'rejected',
            'metadata.updatedOn' : curDate,
        })
    ])

}


export const approvePostExamSurvey = async (docId) => {

    const curDate = getCurrentDateInMillis().toString();
    // get email of the admin user
    const curAuthUser = store.state.user.otherInfo.email;

    return await Promise.all([
        updateDoc(doc(db,'post_exam_survey', docId), {
            status: 'approved',
            'metadata.updatedOn' : curDate,
            'metadata.approvedOn' : curDate,
            'metadata.approvedBy' : curAuthUser
        }),
        updateDoc(doc(db,'claimants', docId), {
            postExamSurveyInfoStatus: 'approved',
            'metadata.updatedOn' : curDate,
        })
    ])

}


export const updateShippingInfo = async (docId, shippingInfo) => {

    const curDate = getCurrentDateInMillis().toString();
    const currentDate = new Date(shippingInfo.shippedOn);
    const shippedOn = currentDate.getTime()
    const nextStatus = shippingInfo.isReturned ? 'returned' : 'shipped'
    const isQueued = !!shippingInfo.isQueued
    const shippingFee = shippingInfo.shippingFee === '' || shippingInfo.shippingFee === null || shippingInfo.shippingFee === undefined
        ? null
        : Number(shippingInfo.shippingFee)
    const feeValue = Number.isFinite(shippingFee) ? shippingFee : null

    return await Promise.all([
        updateDoc(doc(db,'achievement_box', docId), {
            status: nextStatus,
            courierName: shippingInfo.courierName,
            trackingNum: shippingInfo.trackingNum,
            trackingUrl: shippingInfo.trackingUrl,
            shippingFee: feeValue,
            isQueued: isQueued,
            'metadata.shippedOn' : shippedOn.toString(),
            'metadata.shippedBy' : shippingInfo.shippedBy,
            'metadata.updatedOn' : curDate,
            isEmailSent: false
        }),
        updateDoc(doc(db,'claimants', docId), {
            achievementBoxInfoStatus: nextStatus,
            shippingFee: feeValue,
            isQueued: isQueued,
            'metadata.updatedOn' : curDate,
        })
    ])

}

export const forfeitClaimants = async (docId) => {

    const curDate = getCurrentDateInMillis().toString();

    return await Promise.all([
        // updateDoc(doc(db,'achievement_box', docId), {
        //     status: 'shipped',
        //     courierName: shippingInfo.courierName,
        //     trackingNum: shippingInfo.trackingNum,
        //     trackingUrl: shippingInfo.trackingUrl,
        //     'metadata.shippedOn' : shippedOn.toString(),
        //     'metadata.shippedBy' : shippingInfo.shippedBy,
        //     'metadata.updatedOn' : curDate,
        //     isEmailSent: false
        // }),
        updateDoc(doc(db,'claimants', docId), {
            isForfeited: true,
            'metadata.updatedOn' : curDate,
        })
    ])

}

export const updateFacebookPostDate = async (docId, postDate) => {

    const curDate = getCurrentDateInMillis().toString();
    const _postDate = new Date(postDate);
    const postDateFormatted = _postDate.getTime()

    return await Promise.all([
        // updateDoc(doc(db,'achievement_box', docId), {
        //     status: 'shipped',
        //     courierName: shippingInfo.courierName,
        //     trackingNum: shippingInfo.trackingNum,
        //     trackingUrl: shippingInfo.trackingUrl,
        //     'metadata.shippedOn' : shippedOn.toString(),
        //     'metadata.shippedBy' : shippingInfo.shippedBy,
        //     'metadata.updatedOn' : curDate,
        //     isEmailSent: false
        // }),
        updateDoc(doc(db,'claimants', docId), {
            facebookPostDate: postDateFormatted.toString(),
            'metadata.updatedOn' : curDate,
        })
    ])

}

export const updateFacebookPostHoldStatus = async (docId, isHoldPost) => {
    const curDate = getCurrentDateInMillis().toString();

    return await updateDoc(doc(db,'claimants', docId), {
        isHoldPost: isHoldPost,
        'metadata.updatedOn' : curDate,
    })
}

export const updateFacebookPostSpecialStatus = async (docId, isSpecialPost) => {
    const curDate = getCurrentDateInMillis().toString();

    return await updateDoc(doc(db,'claimants', docId), {
        isSpecialPost: isSpecialPost,
        'metadata.updatedOn' : curDate,
    })
}

export const updateQueuedStatus = async (docId, isQueued) => {
    const curDate = getCurrentDateInMillis().toString();

    return await Promise.all([
        updateDoc(doc(db,'achievement_box', docId), {
            isQueued: !!isQueued,
            'metadata.updatedOn' : curDate,
        }),
        updateDoc(doc(db,'claimants', docId), {
            isQueued: !!isQueued,
            'metadata.updatedOn' : curDate,
        })
    ])
}

export const sentEmailUpdateInfo = async (docId) => {

    return await Promise.all([
        updateDoc(doc(db,'achievement_box', docId), {
            isEmailSent: true
        }),
    ])

}